import types from '../../constants';

const initialState = {
  loading: true,
  loadingCompany: false,
  selected: '',
  data: [],
  filter: {
    name: '',
    company: '',
  },
};

const ExercisesReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.EXERCISES_UPDATE:
      return {
        ...state,
        data: action.payload,
      };
    case types.EXERCISES_LOADING_START:
      return {
        ...state,
        loading: true,
      };
    case types.EXERCISES_LOADING_END:
      return {
        ...state,
        loading: false,
      };
    case types.EXERCISES_DELETE_OK:
      state.data = state.data.filter(ex => ex.id !== action.payload);
      return {
        ...state,
      };
    case types.EXERCISES_SELECT:
      return {
        ...state,
        selected: action.payload,
      };
    case types.COMPANIES_FETCH_START:
      return {
        ...state,
        loadingCompanies: true,
      };
    case types.COMPANIES_FETCH_END:
      return {
        ...state,
        companies: action.payload,
        loadingCompanies: false,
      };
    case types.EXERCISES_CHANGE_FILTER:
      const newFilter = { ...state.filter };
      const { key, value } = action.payload;
      newFilter[key] = value;

      return {
        ...state,
        filter: newFilter,
      };
    case types.EXERCISES_RESET_FILTER:
      return {
        ...state,
        filter: {},
      };
    default:
      return state;
  }
};

export default ExercisesReducers;
